import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import Axios from "Source/axiosPool";
import moment from "moment";

import Templates from "./Fields/Templates/Templates";
import Name from "./Fields/Name/Name";
import Hours from "./Fields/Hours/Hours";
import Description from "./Fields/Description/Description";
import WorkstreamLead from "./Fields/WorkstreamLead/WorkstreamLead";
import Color from "./Fields/Color/Color";
import Type from "./Fields/Type/Type";
import SetAsTemplate from "./Fields/SetAsTemplate/SetAsTemplate";
import Details from "./Fields/Details/Details";
import NavigationBLocker from "Components/common/NavigationBlocker/NavigationBlocker"
import WorkstreamEmail from "./Fields/WorkstreamEmail/WorkstreamEmail";
import ModalPortal from "Source/components/common/Modal/ModalPortal";
import ConfirmCreation from "Source/components/project/Common/Modals/ConfirmCreation/ConfirmCreation";
import useForm from "Source/hooks/useForm";
import { getSuggested } from "Source/util/email";
import { showToast } from "Source/globalFunction";
import { EMAIL_SUFFIX } from "Source/components/project/Config/Config";
import { useToggle } from "Source/hooks/useToggle";
import { checkIfAdmin } from "Source/lib/authorization/authorization";
import { getPrefix } from "Source/util/email";
import { confirmationModal, saveWorkstreamForm } from "./Config";
import { connect } from "react-redux";

@connect(store => {
    return {
        project: store.project, 
        loggedUser: store.loggedUser,
    };
})

class WorkstreamForm extends React.Component {
    constructor(props) {
        super(props);

        this.formRef = React.createRef();

        this.state = {
            isUpdated: false,
            isClose: false,
            error: false
        }

        _.map(["onUpdateField", "onSubmit", "onClose", "onUpdateAllFields", "onFetchUsers", "onUpdateWorkstream"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    componentDidUpdate (prevProps) {
        const { confirmSubmit, setConfirmSubmit } = this.props;

        if (confirmSubmit && !_.isEqual(prevProps.confirmSubmit, confirmSubmit)) {
            this.onSubmit(false);
            this.formRef.current.reset();
            setConfirmSubmit(false);
        }
    }

    shouldComponentUpdate( nextProps ) {
        const { dispatch } = this.props;

        if( !_.isEqual( this.props.workstreams.selected, nextProps.workstreams.selected ) && nextProps.workstreams.selected.id && nextProps.workstreams.selected.action === "edit" ) {
            const selected = nextProps.workstreams.selected;
            
            dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELDS", fields: {
                id: selected.id,
                name: selected.workstream,
                type: { value: selected.type.id, label: selected.type.id === 4 ? "Output-based" : "Time-based" },
                email: selected.email,
                hours: selected.numberOfHours,
                description: selected.description,
                color: selected.color,
                workstreamLead: { value: selected.lead.id, label: `${selected.lead.firstName} ${selected.lead.lastName}` },
                isTemplate: Boolean(selected.isTemplate),
                details: [],
                users: []
            }});

            this.setState({
                ...this.state,
                isUpdated: true
            }, () => {
                this.setState({
                    ...this.state,
                    isUpdated: false
                })
            })
        }

        return true;
    }

    onFetchUsers() {
        const { dispatch, project, workstreamForm } = this.props;
        const url = "api/workstream/checkWorkstreamUser";
        const isKeyInDetails = (key) => workstreamForm.fields.details.indexOf( key ) > -1;
        const memberType = [isKeyInDetails("assignee") ? "assignee" : null, isKeyInDetails("reviewer") ? "reviewer" : null, isKeyInDetails("approver") ? "approver" : null].filter(k => k);
        const params = {
            memberType: memberType.join(","),
            workstreamTemplateId: workstreamForm.fields.template.value, 
            projectId: project.Selected.id
        }

        dispatch({ type: "SET_SCREEN_LOADER", Loading: true });

        Axios.get( url, params )
            .then( response => {
                if( response ) {
                    if( response.data.result.length > 0 ) {
                        dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELD", field: { id: "users", value: response.data.result.map( m => ({...m, isSelected: true}) ) }});

                        $( "#accountUsers" ).modal( "show" );

                        dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                    } else {
                        this.onSubmit( true );
                    }
                }
            })
    }

    onUpdateField(e) {
        const { dispatch } = this.props;
        this.setState({
            ...this.state,
            error: e.error !== undefined ? e.error : this.state.error
        }, () => {
            dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELD", field: e.target });
        })
    }
    
    onUpdateWorkstream(e) {
        this.onUpdateField(e);
    }

    onSubmit( proceedToSubmit = false ) {
        const { workstreamForm, fieldEmail, resetHookState } = this.props;
        const isKeyInDetails = (key) => workstreamForm.fields.details.indexOf( key ) > -1;

        if( workstreamForm.type === "fromTemplate" && !proceedToSubmit && (isKeyInDetails("assignee") || isKeyInDetails("approver") || isKeyInDetails("reviewer")) ) {
            this.onFetchUsers();
        } else {
            const { dispatch, project, loggedUser } = this.props;
            const url = "api/workstream";
            const params = {
                color: workstreamForm.fields.color,
                dateUpdated: moment(),
                description: workstreamForm.fields.description,
                isActive: 1,
                isTemplate: workstreamForm.fields.isTemplate,
                numberOfHours: workstreamForm.fields.hours,
                projectId: project.Selected.id,
                responsible: workstreamForm.fields.workstreamLead.value,
                typeId: workstreamForm.fields.type.value,
                userId: loggedUser.data.id,
                workstream: workstreamForm.fields.name,
                workstreamTemplate:workstreamForm.fields.template.value,
                email: fieldEmail.value,
                setting: {
                    assignee: isKeyInDetails("assignee") ? 1 : 0,
                    reviewer: isKeyInDetails("reviewer") ? 1 : 0,
                    approver: isKeyInDetails("approver") ? 1 : 0,
                    dependency: isKeyInDetails("dependency") ? 1 : 0,
                    applicablePeriod: isKeyInDetails("applicablePeriod") ? 1 : 0,
                    description: isKeyInDetails("description") ? 1 : 0,
                }
            }

            dispatch({ type: "SET_SCREEN_LOADER", Loading: true });
            resetHookState();

            if( this.props.workstreams.selected.id ) {
                Axios.put(`${ url }/${ this.props.workstreams.selected.id }`, params,  { timeout: 10000 })
                    .then( response => {
                        if( response ) {
                            dispatch({ type: "UPDATE_DATA_WORKSTREAM_LIST", data: response.data });
                            dispatch({ type: "UPDATE_WORKSTREAMS_CHANGES", boolean: true });
                            
                            $( "#addWorkstreamModal" ).modal( "hide" );

                            // if( this.props.location === "processes" ) {
                            //     showToast( "success", "Changes successfully saved!" );
                            // } else {
                            //     showToast( "success", "Workstream will be added once Member settings are saved" );
                            // }

                            showToast( "success", "Changes successfully saved!" );
                            
                            dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELDS", fields:  {
                                name: null,
                                type: {},
                                hours: 0,
                                description: null,
                                color: null,
                                workstreamLead: {},
                                isTemplate: false,
                                template:{},
                                users: [],
                                details: []
                            }});

                            this.setState({
                                ...this.state,
                                isClose: true
                            }, () => {
                                this.setState({
                                    ...this.state,
                                    isClose: false
                                });
                            });
                        }

                        dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                        dispatch({ type: "UPDATE_WORKSTREAMS_SELECTED", selected: {} });
                        dispatch({ type: "UPDATE_WORKSTREAM_FORM_TYPE", formType: "default" });
                    }).catch(e => {
                        console.error(e);
                        showToast("error", "Something went wrong please try again later.");
                        dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                    });
            } else {
                Axios.post(url, params, { timeout: 10000 })
                    .then( response => {
                        if( response ) {
                            dispatch({ type: "ADD_WORKSTREAM", data: response.data });

                            dispatch({ type: "UPDATE_WORKSTREAMS_CHANGES", boolean: true });

                            // if( this.props.location === "processes" ) {
                            //     showToast( "success", "Workstream successfully added!" );
                            // } else {
                            //     showToast( "success", "Workstream will be added once Member settings are saved" );
                            // }

                            showToast( "success", "Workstream successfully added!" );
                            
                            dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELDS", fields:  {
                                name: null,
                                type: {},
                                hours: 0,
                                description: null,
                                color: null,
                                workstreamLead: {},
                                isTemplate: false,
                                template:{},
                                users: [],
                                details: []
                            }});

                            this.setState({
                                ...this.state,
                                isClose: true
                            }, () => {
                                this.setState({
                                    ...this.state,
                                    isClose: false
                                });
                            });
                        }

                        if( this.props.location !== "processes" ) {
                            dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                        }

                        dispatch({ type: "UPDATE_WORKSTREAMS_SELECTED", selected: {} });
                        dispatch({ type: "UPDATE_WORKSTREAM_FORM_TYPE", formType: "default" });
                        $( "#addWorkstreamModal" ).modal( "hide" );
                    }).catch(e => {
                        console.error(e);
                        showToast("error", "Something went wrong please try again later.");
                        dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                    });;
            }
        }
    }

    onClose() {
        const { dispatch, resetHookState } = this.props;

        resetHookState();
        this.formRef.current.reset();
        this.setState({
            ...this.state,
            error: false,
            isClose: true
        }, () => {
            dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELDS", fields:  {
                id: null,
                name: null,
                email: null,
                type: {},
                hours: 0,
                description: null,
                color: null,
                workstreamLead: {},
                isTemplate: false,
                users: [],
                details: [],
            }});
    
            dispatch({ type: "UPDATE_WORKSTREAMS_SELECTED", selected: {} });
            dispatch({ type: "UPDATE_WORKSTREAM_FORM_TYPE", formType: "default" });

            this.setState({
                ...this.state,
                isClose: true
            });
        });
    }

    onUpdateAllFields( w ) {
        const { dispatch, workstreamForm } = this.props;

        if( w ) {
            dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELDS", fields:  {
                name: w.workstream,
                type: { value: w.type.id, label: w.type.id === 4 ? "Output-based" : "Time-based" },
                hours: w.numberOfHours,
                description: w.description,
                // color: w.color,
                // workstreamLead: w.workstreamMembers.filter( m => m.assign === "responsible" ).map( m => ({ value: m.id, label: `${m.firstname} ${m.lastName}`}) )[0] || {},
                details: workstreamForm.fields.details,
                template: { value: w.id, label: w.workstream },
                users: []
            }});

            this.setState({
                ...this.state,
                // error: true,
                isUpdated: true
            }, () => {
                this.setState({
                    ...this.state,
                    isUpdated: false
                })
            });
        } else {
            dispatch({ type: "UPDATE_WORKSTREAM_FORM_FIELD", field:  {
                id: "template",
                value: {}
            }});
        }
    }

    render() {
        const { 
            workstreamForm,
            project,
            loggedUser,
            isEdit,
            fieldEmail,
            setShowConfirmModal,
            accountNameSuffix,
            setWorkstreamNameTouched,
        } = this.props;
        const {
            props: fieldEmailProps
        } = fieldEmail;
        const isAdmin = checkIfAdmin(loggedUser.data);
        let isSubmitActive = (
            ((workstreamForm.type === "fromTemplate" && workstreamForm.fields.template.value) || workstreamForm.type !== "fromTemplate") &&
            workstreamForm.fields.name && 
            Object.keys(workstreamForm.fields.type).length && 
            workstreamForm.fields.color && 
            workstreamForm.fields.workstreamLead &&
            workstreamForm.fields.workstreamLead.value && 
            !this.state.error
        );

        if (!isEdit || isAdmin) {
            isSubmitActive = isSubmitActive && !!fieldEmailProps.value && fieldEmailProps.valid;
        }
        const onSubmit = isAdmin && isEdit
            ? () => this.onSubmit(false)
            : () => setShowConfirmModal(true);
        
        return (
            <React.Fragment>
                <div class="modal-header bb">
                    <div class="row">
                        <div class="col-lg-10 col-md-10 col-sm-10">
                            <p class="modalTitle">{ isEdit ? "Edit Workstream" : workstreamForm.type === "fromTemplate" ? "Add Workstream from an Existing Template" : "Add New Workstream" }</p>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2">
                            <a  class="text-right text-black" data-dismiss="modal" aria-label="Close" onClick={ this.onClose }>
                                <i class="material-icons text-white text-size22">close</i>
                            </a>
                        </div>
                    </div>    
                </div>
                <div class="modal-body">
                    <form id="workstream-form" ref={this.formRef} >
                        <label class="requiredNote">
                            (<sup>*</sup>) Indicates a required field
                        </label>

                        { workstreamForm.type === "fromTemplate" && (
                            <div class="formSection templateSection">
                                <div class="formContainer bb mb15 pb15">
                                    <label for="template">Select Template <sup>*</sup></label>
                                    <Templates 
                                        onChange={ this.onUpdateAllFields }
                                        isClose={ this.state.isClose }
                                    />
                                </div>
                            </div>
                        )}
                        
                        <div class="formSection">
                            <div class="formContainer">
                                <label for="workstream">Workstream Name <sup>*</sup></label>
                                <Name 
                                    value={ workstreamForm.fields.name } 
                                    workstreamId={ workstreamForm.fields.id } 
                                    projectId={ project.Selected.id } 
                                    onChange={ this.onUpdateWorkstream } 
                                    error={ this.state.error } 
                                    isUpdated={ this.state.isUpdated } 
                                    setWorkstreamNameTouched={setWorkstreamNameTouched}
                                />
                            </div>
                        </div>

                        <div class="formSection">
                            <div class="formContainer workstreamType">
                                <label>Workstream Type <sup>*</sup></label>
                                <Type onChange={ this.onUpdateField } isClose={ this.state.isClose } selected={ workstreamForm.fields.type } />
                            </div>
                        </div>

                        <div class="formSection">
                            <div class={`formContainer numHoursContainer ${ workstreamForm.fields.type.value === 5 ? "" : "disabled" }`}>
                                <label for="number-hours">Number of Hours</label>
                                <Hours 
                                    hours={ workstreamForm.fields.hours } 
                                    type={ workstreamForm.fields.type.value }
                                    onChange={ this.onUpdateField }
                                    isUpdated={ this.state.isUpdated }
                                />
                            </div>
                        </div>

                        <div class="formSection">
                            <div class="formContainer">
                                <label for="description">Description</label>
                                <Description value={ workstreamForm.fields.description } onChange={ this.onUpdateField } isUpdated={ this.state.isUpdated } />
                            </div>
                        </div>

                        <div class="formSection">
                            <div class="formContainer colorPicker">
                                <label for="project-manager">Color Indicator <sup>*</sup></label>
                                <Color 
                                    color={ workstreamForm.fields.color } 
                                    onChange={ this.onUpdateField } 
                                />
                            </div>
                        </div>

                        <div class="formSection">
                            <div class="formContainer">
                                <label>Workstream Lead <sup>*</sup></label>
                                <WorkstreamLead 
                                    selected={ workstreamForm.fields.workstreamLead }
                                    onChange={ this.onUpdateField }
                                    isClose={ this.state.isClose } 
                                />
                            </div>
                        </div>

                        <WorkstreamEmail 
                            email={workstreamForm.fields.email} 
                            isEdit={isEdit}
                            fieldEmailProps={fieldEmailProps} 
                            accountNameSuffix={accountNameSuffix}
                        />

                        { workstreamForm.type === "fromTemplate" && ( 
                            <div class="formSection">
                                <div class="formContainer detailsToCopy">
                                    <label for="workstream">Select Task Details to Copy</label>
                                    <Details value={ workstreamForm.fields.details } onChange={ this.onUpdateField } />
                                </div>
                            </div>
                        )}
                    </form>
                </div>
                <div class="modal-footer">
                    <div class="modalActions">
                        <SetAsTemplate checked={ workstreamForm.fields.isTemplate } onChange={ this.onUpdateField } />
                        <div>
                            <button type="button" class={`btn btn-secondary btn-cancel-bg ${ isSubmitActive ? "active" : "" }`} data-dismiss="modal" onClick={ this.onClose }>Cancel</button>
                            <button type="button" class={`btn btn-create ${ !isSubmitActive ? "disabled" : "" }`} onClick={onSubmit}>Save</button>
                        </div>
                    </div>
                </div>
                <NavigationBLocker navigationBlocked={isSubmitActive}/>

            </React.Fragment>
        );
    }
}

const withHooks = Component => props => {
    const { accountNameSuffix, workstreamForm, isEdit} = props;
    const { fields, type: formType } = workstreamForm;
    const { email: workstreamEmail, name: workstreamName } = fields
    const formConfig = saveWorkstreamForm({ accountNameSuffix, workstreamId: workstreamForm.fields.id });
    const { registerFormInput, resetForm, setDefaultValues, setFormFieldValue } = useForm({ validationRules: formConfig.email.validationRules });
    const [showConfirmModal, setShowConfirmModal] = useToggle(false);
    const [confirmSubmit, setConfirmSubmit] = useState(false);
    const [workstreamNameTouched, setWorkstreamNameTouched] = useState(false);
    const fieldEmailProps = registerFormInput(
        'email'
    );
    const fieldEmail = {
        props: fieldEmailProps,
        value: `${fieldEmailProps.value}-${accountNameSuffix}`,
    };

    useEffect(() => {
        if (!isEdit || !workstreamEmail) {
            return;
        }

        const formattedEmail = getPrefix(workstreamEmail, '-')

        setDefaultValues({
            email: formattedEmail
        })
        
    }, [isEdit, workstreamEmail])

    useEffect(() => {
        if (isEdit && !workstreamNameTouched) {
            return;
        }
        
        const suggestedEmail = getSuggested(workstreamName || '');
        setFormFieldValue('email', suggestedEmail);
          
        if (workstreamName) {
            fieldEmailProps.onValidate({
                target: {
                    name: 'email',
                    value: suggestedEmail
                }
            })
        }
    }, [workstreamName, workstreamNameTouched, isEdit]);

    const submitForm = useCallback(() => {
        setShowConfirmModal(false);
        setConfirmSubmit(true);
    }, []);

    const resetHookState = useCallback(() => {
        setShowConfirmModal(false);
        setConfirmSubmit(false);
        setWorkstreamNameTouched(false)
        resetForm();
    }, [fieldEmail]);
    
    return <React.Fragment>
        <Component {...props} 
            fieldEmail={fieldEmail}
            showConfirmModal={showConfirmModal}
            setShowConfirmModal={setShowConfirmModal}
            confirmSubmit={confirmSubmit}
            setConfirmSubmit={setConfirmSubmit}
            resetHookState={resetHookState}
            accountNameSuffix={accountNameSuffix}
            setWorkstreamNameTouched={setWorkstreamNameTouched}
        />
        {showConfirmModal && 
            <ModalPortal>
                <ConfirmCreation
                    title={confirmationModal.title}
                    body={confirmationModal[formType].body(fieldEmail.value)}
                    onClose={()=> setShowConfirmModal(false)}
                    onConfirm={submitForm}
                />
            </ModalPortal>
        }
    </React.Fragment>
};

export default withHooks(WorkstreamForm);